import SearchIcon from "@mui/icons-material/Search";
import { Grid, Paper, InputBase, IconButton } from "@mui/material";
import React from "react";
import parse from "html-react-parser";

export const EnhancedTableToolbar = (props) => {
  return (
    <Grid sx={{ flexGrow: 1 }} container spacing={2}>
      <Grid item xs={12} sx={{ width: { xs: "100%", sm: "100%", md: "100%", lg: "100%" } }} className="inspection-toolbar-main">
        <Paper
          elevation={0}
          className={"inspection-search-field"}
          sx={{
            p: "2px 4px",
            display: "flex",
            alignItems: "center",
            width: { xs: "241px", sm: "29.64%", md: "29.64%", lg: "29.64%" },
          }}>
          <IconButton sx={{ p: "10px" }} aria-label="search">
            <SearchIcon className="inspection-search-icon" />
          </IconButton>
          <InputBase sx={{ ml: 1, flex: 1, fontSize: "16px" }} placeholder="Search template library" inputProps={{ "aria-label": "search" }} onChange={props.handleSearchFilter} />
        </Paper>
      </Grid>
      <Grid item xs={12}></Grid>
    </Grid>
  );
};
export function descendingComparator(a, b, orderBy) {
  function stripHtmlTags(str) {
    return str.replace(/<[^>]*>?/gm, "");
  }
  if (orderBy === "rating") {
    if (a["summaries"][0]?.summary?.name === null || a["summaries"][0]?.summary?.name === undefined) return 1;
    if (b["summaries"][0]?.summary?.name === null || b["summaries"][0]?.summary?.name === undefined) return -1;
    if (b["summaries"][0]?.summary?.name?.toLowerCase() < a["summaries"][0]?.summary.name?.toLowerCase()) {
      return -1;
    }
    if (b["summaries"][0]?.summary?.name?.toLowerCase() > a["summaries"][0]?.summary?.name?.toLowerCase()) {
      return 1;
    }
    return 0;
  } else {
    if (a[orderBy] === null) return 1;
    if (b[orderBy] === null) return -1;
    const aValue = stripHtmlTags(String(a[orderBy])).toLowerCase();
    const bValue = stripHtmlTags(String(b[orderBy])).toLowerCase();
    const aIsNumber = !isNaN(parseFloat(aValue)) && isFinite(aValue);
    const bIsNumber = !isNaN(parseFloat(bValue)) && isFinite(bValue);

    if ((aIsNumber && bIsNumber) || (!aIsNumber && !bIsNumber)) {
      if (bValue < aValue) {
        return -1;
      }
      if (bValue > aValue) {
        return 1;
      }
      return 0;
    }

    if (aIsNumber && !bIsNumber) {
      return -1;
    }
    if (!aIsNumber && bIsNumber) {
      return 1;
    }
  }
}
export function stableSort(commentListArray, comparator) {
  const stabilizedThis = commentListArray?.map((el, index) => [el, index]);
  stabilizedThis?.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis?.map((el) => el[0]);
}

export const replacePlaceholdersWithDropdowns = (htmlString, dropdowns, type, commentUUid) => {
  const isValidSelectedValue = (val) => {
    if (val === null || val === undefined) return false;
    const str = String(val).trim();
    return str !== "" && str.toLowerCase() !== "null" && str.toLowerCase() !== "undefined" && !str.includes("------");
  };
  const regexSpecialSymbol = /Ã‚|Â|Ã‚Â/g;
  function decodeEntities(encodedString) {
    const textarea = document.createElement("textarea");
    textarea.innerHTML = encodedString;
    return textarea.value;
  }
  dropdowns.forEach((dropdown) => {
    const placeholder = `\\[dropdown ${dropdown.dropdown_uuid}\\]`;
    const regex = new RegExp(placeholder, "g");
    const selectElement = document.createElement("select");
    const option = document.createElement("option");
    option.text = "-------------";
    option.value = "";
    selectElement.appendChild(option);
    const hasValidSelectedValue = isValidSelectedValue(dropdown?.selected_value);
    if (!hasValidSelectedValue) {
      option.setAttribute("selected", "selected");
    }
    let newDropdownValues = Array.isArray(dropdown.dropdowns_values) ? [...dropdown.dropdowns_values] : [];
    if (hasValidSelectedValue) {
      const hasSelected = newDropdownValues.some(val => val?.trim() === dropdown.selected_value?.trim());
      if (!hasSelected) {
        newDropdownValues.push(dropdown.selected_value);
      }
    }
    newDropdownValues.forEach((value) => {
      const option = document.createElement("option");
      if (value?.length > 40) option.text = `${value.substring(0, 40)}...`;
      else option.text = value;
      option.value = value;
      option.title = value;
      selectElement.appendChild(option);
      if (hasValidSelectedValue && dropdown.selected_value === value) {
        option.setAttribute("selected", "selected");
      }
      selectElement.classList.add(`${type}-cl-detail-dropdown`);
      selectElement.setAttribute("id", `${dropdown.dropdown_uuid}`);
      selectElement.setAttribute("dropType", type);
      selectElement.setAttribute("comment_uuid", commentUUid);
    });
    htmlString = htmlString.replace(regex, selectElement.outerHTML);
  });
  return parse(decodeEntities(htmlString?.replace(regexSpecialSymbol, "")));
};

export function preprocessHTMLContent(htmlContent) {
  if (!htmlContent || typeof htmlContent !== "string") return "";
  const kept = htmlContent.replace(/<(?!input\b)[\s\S]*?>/gi, "");
  return kept.replace(/\u00A0/g, " ").replace(/&nbsp;/gi, " ").trim();
}

export function filterSelectTag(htmlText) {
  if (!htmlText) return "";
  var tempContainer = document.createElement("div");
  var container = document.createElement("p");
  container.innerHTML = htmlText;
  while (tempContainer.firstChild) {
    container.appendChild(tempContainer.firstChild);
  }
  var spans = container.querySelectorAll("span[id^='dropdown_'], span[id^='[dropdown '], span");
  spans.forEach((span) => {
    let spanId = span.id?.trim();
    const dropdownMatch = spanId.match(/^dropdown_(.+)$/) || spanId.match(/^\[dropdown (.+)\]$/);
    if (dropdownMatch) {
      const uuid = dropdownMatch[1];
      span.outerHTML = `[dropdown ${uuid}]`;
    }
  });
  var inputs = container.querySelectorAll("input");
  inputs.forEach((input) => {
    const escapeHTML = (str) => str.replace(/"/g, "&quot;")
    let id = input.id ? `id:${input.id}; ` : "";
    let value = input.value ? `value:${escapeHTML(input.value)}; ` : "";
    let placeholder = `[textbox ${id}${value}]`.trim();
    input.outerHTML = `${placeholder} <div> </div>`;
  });
  container.innerHTML = container.innerHTML.replace(/\s+/g, " ").replace(/<div>\s*<\/div>/g, "").replace(/<p>(\s|<br\s*\/?>)*<\/p>/g, "").trim();
  return container.innerHTML;
}

export function filterSelectTagIntro(htmlText) {
  if (!htmlText) return "";
  var tempContainer = document.createElement("div");
  var container = document.createElement("p");
  container.innerHTML = htmlText;
  while (tempContainer.firstChild) {
    container.appendChild(tempContainer.firstChild);
  }
  var spans = container.querySelectorAll("span[id^='dropdown_'], span[id^='[dropdown ']");
  spans.forEach((span) => {
    var spanId = span.id.replace("dropdown_", "").trim();
    if (spanId) {
      span.outerHTML = spanId.includes("dropdown") ? spanId : `[dropdown ${spanId}]`;
    }
  });
  var inputs = container.querySelectorAll("input");
  inputs.forEach((input) => {
    const escapeHTML = (str) => str.replace(/"/g, "&quot;")
    let id = input.id ? `id:${input.id}; ` : "";
    let value = input.value ? `value:${escapeHTML(input.value)}; ` : "";
    let placeholder = `[textbox ${id}${value}]`.trim();
    input.outerHTML = `${placeholder} <div> </div>`;
  });
  container.innerHTML = container.innerHTML.replace(/\s+/g, " ").replace(/<div>\s*<\/div>/g, "").replace(/<p>(\s|<br\s*\/?>)*<\/p>/g, "").trim();
  return container.innerHTML;
}

